// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'
import { UpdatedLabeledInputWrapper } from 'components/Form/updated/UpdatedLabeledInput/styles'

export const UpdatedMultiSelectWrapper = styled(UpdatedLabeledInputWrapper)`
  grid-template-rows: repeat(2, auto) 1fr;

  > .input {
    border: 0;
    height: auto;
    padding: 0;
    overflow: visible;

    &.react-select--is-disabled {
      cursor: not-allowed;
      pointer-events: all;

      > .react-select__control {
        cursor: not-allowed;
        pointer-events: none;
      }
    }

    > .react-select__control {
      border-color: currentColor;
    }
  }
`
